// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

export default css`
  &.navigation {
    position: relative;
  }
`;

export const StoreAndHelpLinkWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  background: #f3f3f3;
  gap: 12px;

  @media ${(props) => props.theme.mediaQuery.large} {
    display: none;
  }

  .help-icon,
  .find-a-store-icon {
    display: inline-block;
    width: 30px;
    height: 30px;
  }

  .nav-drawer-link-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .find-a-store-wrapper {
    border: none;
    background: transparent;
    padding: 0;
  }

  .nav-drawer-link-label {
    color: #000;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: 0.14px;
  }
`;
